import React, { useRef } from 'react';
import { Container, EntryAnimation } from '../../atoms';
import { BadgeCard } from '../../molecules';
export default function BadgeCardListSection(param) {
    var entries = param.entries, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: BadgeCardListSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-cols-max gap-6 md:gap-3"
    }, entries.map(function(entry, entryIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(entry.title),
            view: containerRef,
            delay: (entryIndex + 1) / 5
        }, /*#__PURE__*/ React.createElement(BadgeCard, entry));
    })));
}

//# sourceMappingURL=BadgeCardListSection.js.map